interface GiftCardType {
    available_payment_methods: [],
    flags: {},
    purchase_info: {}[],
  }
  
  export const giftCardDataTransformer = (data: GiftCardType) => ({
    availablePaymentMethods: data.available_payment_methods,
  });
  
  